import FiltersContext from '@/context/FiltersContext/FiltersContext';
import { translateDynamicKey } from '@/types/translation';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Popover from '@/storybook/components/Popover/Popover';
import Text from '@/storybook/components/Text/Text';
import styles from './WelcomePopover.module.css';
interface WelcomePopoverProps {
  onClose?: () => void;
  anchor?: React.ReactNode;
  showWelcomeMessage?: boolean;
  className?: string;
  horizontalOffset: number;
}

const WelcomePopover = ({
  onClose,
  anchor,
  showWelcomeMessage,
  className = undefined,
  horizontalOffset,
}: WelcomePopoverProps) => {
  const { t } = useTranslation();
  const { activeFilters } = useContext(FiltersContext);

  const descriptionText = 'global.filters.welcomePopover.' + (activeFilters.length > 0 ? 'body1' : 'body2');

  return (
    <Popover
      className={className}
      defaultIsOpen={showWelcomeMessage}
      disabled={!showWelcomeMessage}
      horizontalOffset={horizontalOffset}
      noticePosition={'bottom'}
      appearance="primary"
      anchorContent={anchor}
      title={t('global.filters.welcomePopover.title')}
      onClose={onClose}
      noticeContent={
        <div className={styles.contentWrapper}>
          <Text as="p" className={styles.welcomeMessage}>
            {translateDynamicKey(t, descriptionText)}
          </Text>
        </div>
      }
    />
  );
};

export default WelcomePopover;
